/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import PropTypes from "prop-types";
import Image from "Components/image-with-fallback";

const Mobile = ({
	attr, name, generalPrice, price, options, qty,
}) => (
	<div
		className="cart-item"
		style={{ opacity: attr?.is_in_stock === 0 ? "0.5" : "1" }}
	>
		<div style={{ width: "100%" }}>
			<div className="product-info">
				<div className="product-image">
					<Image src={attr?.image_url} alt="" />
				</div>
				<div>
					<span className="brand">{attr?.brand_name}</span>
					<span className="name">{name}</span>
					{options?.map((item, index) => {

						const option = `${
							item?.extension_attributes?.value ?? ""
						}`;
						return (
							<div
								className="option-item"
								key={`desktop-${option}-${String(index)}`}
							>
								{option}
							</div>
						);

					})}
					{qty !== undefined && (
						<span className="qty">
							{qty}
							{" "}
							Pcs
						</span>
					)}

					<span className="price">{price}</span>
					{generalPrice && (
						<span className="price-discount">{generalPrice}</span>
					)}
					{attr?.discount_label && (
						<span className="discount-label">{`${attr?.discount_label} Off`}</span>
					)}
				</div>
			</div>
		</div>
		<style>
			{`
				.cart-item {
					display: flex;
					position: relative;
					box-sizing: border-box;
					width: 100%;
				}
				.product-info {
					display: flex;
				}
				.product-info .product-image {
					position: relative;
					margin-right: 12px;
					width: 100%;
					height: 100%;
					max-width: 72px !important;
					max-height: 72px !important;
					min-width: 72px !important;
					min-height: 72px !important;
				}
				.product-info div {
					display: flex;
					flex-direction: column;
				}
				.product-info div .name {
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: 12px;
					letter-spacing: 0em;
					margin-bottom: 4px;
				}
				.product-info div .price {
					font-style: normal;
					font-weight: 600;
					font-size: 14px;
					line-height: 22px;
					margin-top: 8px;
				}
				.product-info div .price-discount{
					font-style: normal;
					font-weight: 400;
					font-size: 12px;
					line-height: 18px;
					margin : 2px 0px;
					color: #919EAB;
					text-decoration: line-through;
				}
				.product-info div .discount-label{
					font-style: normal;
					font-weight: 600;
					font-size: 12px;
					line-height: 16px;
					color: #FF4D4F;
				}
				.product-info div .brand {
					font-size: 12px;
					line-height: 16px;
					letter-spacing: 0em;
					font-weight: 600;
					margin-bottom: 4px;
				}
				.option-item {
					
					font-size: 12px;
					font-weight: 400;
					line-height: 16px;
					letter-spacing: 0.04em;
					text-align: left;
					color: #637381;
					margin-bottom: 2px;
				}
				.qty {
					
					font-size: 14px;
					font-weight: 400;
					line-height: 22px;
					letter-spacing: .04em;
					text-align: left;
					color: #637381;
					word-break: break-word;
				}
			`}
		</style>
	</div>
);

Mobile.propTypes = {
	attr: PropTypes.any.isRequired,
	name: PropTypes.string.isRequired,
	price: PropTypes.any.isRequired,
	generalPrice: PropTypes.any,
	options: PropTypes.any,
	qty: PropTypes.any,
};

export default Mobile;
